export default __webpack_public_path__ + "static/igenizzazione-d16b53d8cbe1cd421e9479bf02bc8cce.png";